export function checkPermission(permission: string) {
    return function (
        target: Object,
        propertyKey: string|symbol,
        descriptor: PropertyDescriptor
    ) {
        const originalMethod = descriptor.value;

        descriptor.value = function (...args: any[]) {
            const permissions = localStorage.getItem('permissions');

            if (!permissions) {
                throw new Error("Permissions not found");
            }

            const hasPermission = JSON.parse(permissions).find((permision: string) => permision === permission);

            if (!hasPermission) {
                throw new Error(`No se pueden realizar esta acción porque no tiene permisos ${permission}`);
            }

            return originalMethod.apply(this, args);
        };

        return descriptor;
    };
}
